<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 52 52"
    :fill="background"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26 49.4C38.9235 49.4 49.4 38.9235 49.4 26C49.4 13.0765 38.9235 2.6 26 2.6C13.0765 2.6 2.6 13.0765 2.6 26C2.6 38.9235 13.0765 49.4 26 49.4ZM26 52C40.3594 52 52 40.3594 52 26C52 11.6406 40.3594 0 26 0C11.6406 0 0 11.6406 0 26C0 40.3594 11.6406 52 26 52Z"
      :fill="background"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26 52C40.3594 52 52 40.3594 52 26C52 11.6406 40.3594 0 26 0C11.6406 0 0 11.6406 0 26C0 40.3594 11.6406 52 26 52Z"
      :fill="background"
    />
    <rect
      x="17.6802"
      y="24.6128"
      width="16.64"
      height="2.77333"
      rx="1"
      fill="white"
    />
    <rect
      x="27.3867"
      y="17.6797"
      width="16.64"
      height="2.77333"
      rx="1"
      transform="rotate(90 27.3867 17.6797)"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: "IconPlus",

  props: {
    // цвет иконки
    background: {
      type: String,
      default() {
        return this.$vuetify.theme.primary;
      },
    },
    // размер
    size: {
      type: String,
      default: "52",
    },
  },
};
</script>
